document.addEventListener("click", function(e) {
  let el = e.target.closest("a");

  if (!el) return;

  const href = el.getAttribute("href");

  // Blocca SOLO la pagina /cart, non i JS
  if (href === "/cart" || href === "https://www.miamily.com/cart" || href.startsWith("/cart?")) {
    e.preventDefault();
    return false;
  }
});
